import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import AdvisorGrowBusinessDrawer from './AdvisorGrowBusinessDrawer';

const AdvisorGrowBusinessBanner = ({ open, setOpen, accordion, setAccordion }) => {
  return (
    <>
      {/* Clickable Banner */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2, py: 1, borderTop: '1px solid var(--color_ddd)', borderBottom: '1px solid var(--color_ddd)', cursor: 'pointer' }}
        onClick={() => setOpen(true)}
      >
        {/* Left side: Icon + Text */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <CampaignIcon htmlColor="#ef8d34" />
          <Typography variant="body1" sx={{ color: '#06c' }}>Grow Your Business</Typography>
        </Stack>

        {/* Right side: Arrow Icon */}
        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
      </Stack>

      <AdvisorGrowBusinessDrawer
        open={open}
        onClose={() => setOpen(false)}
        accordion={accordion}
        setAccordion={setAccordion}
      />
    </>
  );
};

AdvisorGrowBusinessBanner.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  accordion: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  setAccordion: PropTypes.func.isRequired,
};

export default AdvisorGrowBusinessBanner;
